import React__default from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import ModalContent from './ModalContent.js';

var propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  classList: PropTypes.string,
  closeButtonLabel: PropTypes.string,
  closeButtonTheme: PropTypes.oneOf(['', 'inverse']),
  footer: PropTypes.node,
  heading: PropTypes.node,
  isFullBleed: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  isOpen: PropTypes.bool,
  isSticky: PropTypes.bool,
  isToaster: PropTypes.bool,
  onClose: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onOpen: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.string),
  variant: PropTypes.oneOf(['', 'headerless'])
};
var returnUndefined = function returnUndefined() {
  return undefined;
};
function Modal(_ref) {
  var children = _ref.children,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    _ref$closeButtonLabel = _ref.closeButtonLabel,
    closeButtonLabel = _ref$closeButtonLabel === void 0 ? '' : _ref$closeButtonLabel,
    _ref$closeButtonTheme = _ref.closeButtonTheme,
    closeButtonTheme = _ref$closeButtonTheme === void 0 ? '' : _ref$closeButtonTheme,
    footer = _ref.footer,
    heading = _ref.heading,
    id = _ref.id,
    isFullBleed = _ref.isFullBleed,
    _ref$isFullscreen = _ref.isFullscreen,
    isFullscreen = _ref$isFullscreen === void 0 ? false : _ref$isFullscreen,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$isSticky = _ref.isSticky,
    isSticky = _ref$isSticky === void 0 ? false : _ref$isSticky,
    _ref$isToaster = _ref.isToaster,
    isToaster = _ref$isToaster === void 0 ? false : _ref$isToaster,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? returnUndefined : _ref$onClose,
    _ref$onMouseLeave = _ref.onMouseLeave,
    onMouseLeave = _ref$onMouseLeave === void 0 ? null : _ref$onMouseLeave,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? returnUndefined : _ref$onOpen,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? null : _ref$style,
    variant = _ref.variant;
  if (!isOpen) return null;
  var props = {
    children: children,
    classList: classList,
    closeButtonLabel: closeButtonLabel,
    closeButtonTheme: closeButtonTheme,
    footer: footer,
    heading: heading,
    id: id,
    isFullBleed: isFullBleed,
    isFullscreen: isFullscreen,
    isOpen: isOpen,
    isSticky: isSticky,
    isToaster: isToaster,
    onClose: onClose,
    onMouseLeave: onMouseLeave,
    onOpen: onOpen,
    style: style,
    variant: variant
  };
  return /*#__PURE__*/createPortal(/*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ModalContent, props, children)), document.body);
}
Modal.propTypes = propTypes;

export { Modal as default };
//# sourceMappingURL=Modal.js.map
